module.exports = __webpack_public_path__ + "static/media/menu.0a349ea3.svg";